// extracted by mini-css-extract-plugin
export default {"loader":"loading_styles_loader__fiyBH","load1":"loading_styles_load1__SoLI+","loaderWrapper":"loading_styles_loaderWrapper__VPRtN"};